// 门店系统
import { getStoreAuth } from '@/utils/http/modules/agent/auth.request'
import storeConfigModel from '@/controllers/storeController/models/config/config.model'
import StoreController from '@/controllers/storeController/view/store/store.controller.js'
import { PERMISSION_MAP } from '@/controllers/storeController/models/data/permission/permission.model'
import { getLocal } from '@/utils/utils'
import ConfigModel from '@store/models/config/config.model'
// 权限检查函数
const checkPermission = (code, permissions, userType) => {
  const mapping = PERMISSION_MAP[code]
  if (!mapping) return false
  const actualCode = mapping[userType]
  return actualCode && permissions.find(item => item.permCode === actualCode)
}

export default {
  state: {
    permissions: [],
    permissionPromise: null,
  },
  getters: {
    hasPermi: state => permissionCode => {
      if (!state.permissions?.length) return false
      let userType = getLocal(ConfigModel['USER_INFO_KEY'])?.type || 0

      if (Array.isArray(permissionCode)) {
        return permissionCode.some(code =>
          checkPermission(code, state.permissions, userType)
        )
      }

      return checkPermission(permissionCode, state.permissions, userType)
    },
  },
  mutations: {},
  actions: {
    async getPermissions({ state }) {
      if (!state.permissionPromise) {
        let userType = getLocal(ConfigModel['USER_INFO_KEY'])?.type || 0
        let res = await getStoreAuth({
          rolecode: storeConfigModel.ROLECODE_MAP[userType],
        })
        state.permissions = res.data || []
        state.permissionPromise = true
      }
    },
  },
}
